module.exports = __webpack_public_path__ + "img/offer.dfb67629.png";